(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingGradeSelectorItemDriveaway", function () {
    var controller = [
      "$scope",
      function ($scope) {
        var ctl = this;

        function init() {
          $scope.driveawayPrice = $scope.driveawayPrice ? $scope.driveawayPrice : {};
          $scope.driveawayPrice.materialCode = ctl.materialCode;
          $scope.driveawayPrice.fetchPriceAndRepaint();
        }

        if (ctl.defaultTray !== "") {
          $scope.driveawayPrice.accessoryCodes = [ctl.defaultTray];
        }

        this.$onInit = init;

        $scope.$on("GeoPostCode", function () {
          $scope.driveawayPrice = $scope.driveawayPrice ? $scope.driveawayPrice : {};
          $scope.driveawayPrice.price = 0;
          $scope.driveawayPrice.materialCode = ctl.materialCode;
          $scope.driveawayPrice.fetchPriceAndRepaint();
        });

        $scope.$watch("driveawayPrice.price", function () {
          $scope.$emit("gradeBaseDriveawayPrice", {
            gradeId: ctl.gradeId,
            driveawayPrice: $scope.driveawayPrice.price,
          });
        });
      },
    ];

    return {
      scope: true,
      restrict: "A",
      controller: controller,
      bindToController: {
        gradeId: "@gradeId",
        materialCode: "@materialCode",
        defaultTray: "@defaultTray",
      },
      controllerAs: "tyPricingPageGradeSelectorItem",
    };
  });
})(window.angular);
